import CallCenterCrmModal from './CallCenterCrmModal'
var CallCenter = new CallCenterCrmModal()
export default CallCenter



// WEBPACK FOOTER //
// ./src/api/CallCenterCrm.js